import { loadData, saveData } from '@/utils/localStorage'
import { LOCAL_STORAGE_CONFIG_KEY } from '@/constants/config'

export function getDefaultConfig() {
  return {
    animation: true,
    ordersOnChart: true,
    lockLayout: false
  }
}

export function loadConfig() {
  let userConfig = loadData(LOCAL_STORAGE_CONFIG_KEY)
  if (!userConfig) {
    userConfig = getDefaultConfig()
    saveConfig(userConfig)
  }
  return userConfig
}

export function saveConfig(config) {
  saveData(LOCAL_STORAGE_CONFIG_KEY, config)
}
